import {NgModule} from '@angular/core';
import {DrawingComponentModule} from 'app/drawing/component/component.module';
import {DrawingServiceModule} from 'app/drawing/service/service.module';

@NgModule({
    imports: [DrawingServiceModule, DrawingComponentModule],
    exports: [DrawingServiceModule, DrawingComponentModule],
})
export class DrawingModule {}
